import React, {useEffect, useState} from "react";
import {IsOnboardedContext} from "../../Contexts/IsOnboardedContext";
import {apiClient} from "../../API/api";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import {useKindeAuth} from "@kinde-oss/kinde-auth-react";
import LoggedOut from "../../Pages/Auth/LoggedOut";

const UserState = ({children}) => {
    const { login, isAuthenticated, isLoading, user, getToken, getClaim } = useKindeAuth();
    const [tenantCode, setTenantCode] = useState();
    const [orgDetails, setOrgDetails] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        const hasLoggedOut = sessionStorage.getItem('hasLoggedOut');
        if (!isLoading && !isAuthenticated && !hasLoggedOut) {
            login().then(r => console.log(r));
        }
    }, [isLoading, isAuthenticated, login]);

    useEffect(() => {
        if (isAuthenticated) {
            sessionStorage.removeItem('hasLoggedOut');
        }
    }, [isAuthenticated]);

    useEffect(() => {
        const fetchClaims = async () => {
            try {
                const orgProperties = await getClaim('organization_properties');
                setTenantCode(orgProperties?.value?.tenantcode?.v || null);
                const orgName = await getClaim('org_name');
                const orgCode = await getClaim('org_code');
                setOrgDetails({
                    name: orgName.value,
                    code: orgCode.value,
                    tenantCode: orgProperties?.value?.tenantcode?.v || null,
                    customerCode: orgProperties?.value?.customercode?.v || null,
                })
            } catch (error) {
                console.error('Error fetching claims:', error);
            }
        };

        if (isAuthenticated && user) {
            fetchClaims().then();
        }
    }, [isAuthenticated, user, getClaim]);

    useEffect(() => {
        const requestInterceptor = apiClient.interceptors.request.use(
            async (config) => {
                try {
                    // Get a fresh token for each request
                    const accessToken = await getToken();
                    const givenName = await getClaim("given_name", "id_token");
                    const familyName = await getClaim("family_name", "id_token");
                    const fullName = `${givenName.value} ${familyName.value}`;
                    if (accessToken) {
                        setAccessToken(accessToken);
                        config.headers.Authorization = `Bearer ${accessToken}`;
                        config.headers['X-User-Name'] = fullName;
                    } else {
                        console.warn('No access token available for request');
                    }
                    return config;
                } catch (error) {
                    console.error('Error setting up request headers:', error);
                    return config;
                }
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        return () => {
            apiClient.interceptors.request.eject(requestInterceptor);
        };
    }, []);


    if (isLoading) {
        return <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
            <CircularProgress color="primary" />
        </Box>;
    }

    if (!isAuthenticated) {
        const hasLoggedOut = sessionStorage.getItem('hasLoggedOut');
        if (hasLoggedOut) {
            return <LoggedOut />;
        }

        return <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
            <CircularProgress color="primary" />
        </Box>;
    }

    if (tenantCode !== undefined) {
        return (
            <IsOnboardedContext.Provider value={{
                onboardedStatus: !!tenantCode,
                user,
                userName: `${user.givenName} ${user.familyName}`,
                loggedIn: isAuthenticated,
                orgDetails,
                accessToken
            }}>
                {children}
            </IsOnboardedContext.Provider>
        );
    }
}

export default UserState;